<div class="container">
  <div class="modal-header">
    <h4 class="modal-title">Download map</h4>
    <div>
      <button type="button" class="btn btn-secondary" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [ngSwitch]="step">
      <div *ngSwitchCase="0">
        <div class="row">
          <div *ngIf="tooBig"
                class="alert alert-warning">
            Area too large. Zoom in further or select a smaller region.
          </div>
          <div *ngIf="!tooBig"
                class="alert alert-success">
            Please complete the form below to request data. Rate limits apply.
          </div>
        </div>
        <div class="row">
          <hr/>
          <div class="col-12">
            <p>Filling out this form will let you send us an email with the specified data request.</p>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-xl-12 col-xxl-4">
            <label for="name">name</label>
          </div>
          <div class="col-xl-12 col-xxl-8">
            <input type="text" id="name" class="form-control form-control-sm" placeholder="Your name" required [(ngModel)]="name">
          </div>
        </div>

        <div class="row form-group">
          <div class="col-xl-12 col-xxl-4">
            <label for="name">email</label>
          </div>
          <div class="col-xl-12 col-xxl-8">
            <input type="text" id="email" class="form-control form-control-sm" placeholder="you@youremail" required [(ngModel)]="email">
          </div>
        </div>

        <div class="row form-group">
          <div class="col-xl-12 col-xxl-4">
            <label for="reason">reason for request</label>
          </div>
          <div class="col-xl-12 col-xxl-8">
            <textarea id="reason"
                      class="form-control form-control-sm"
                      placeholder="In a few words, describe what you would like to use the data for."
                      required
                      rows="6"
                      [(ngModel)]="reasonForRequest"></textarea>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-xl-12 col-xxl-4">
            <label for="wms-url">data requested</label>
          </div>
          <div class="col-xl-12 col-xxl-8">
            <input type="text"
                  id="wms-url"
                  class="form-control form-control-sm"
                  readonly
                  [(ngModel)]="dataExpression">
            <small class="note"><i>This field is auto-populated. The contents tell us which data you are currently at.</i></small>

          </div>
        </div>

        <div class="row form-group">
          <div class="col-xl-12 col-xxl-4">
            <label for="wms-url">area of interest</label>
          </div>
          <div class="col-xl-12 col-xxl-8">
            <textarea type="text"
                  id="wms-url"
                  class="form-control form-control-sm"
                  rows="5"
                  readonly
                  [(ngModel)]="areaOfInterest"></textarea>
            <small class="note"><i>This field is auto-populated. The contents tell us
              the area you are currently looking at.
              If you have a polygon selected, we will use the bounding rectangle of that polygon.
            If you do not have a polygon selected, we will use the visible extent of the map.</i></small>
          </div>
        </div>

        <div class="row">
          <div >
            <button  class="btn btn-primary"
                     (click)="requestData()"
                     [disabled]="tooBig">Request data</button>
          </div>
          <div *ngIf="requestResult"
                class="alert" [ngClass]="{
                  'alert-success': resultType === 'success',
                  'alert-danger': resultType !== 'success'
                }">
            {{requestResult}}
          </div>
        </div>
      </div>

      <div *ngSwitchCase="1">
        <p>Choropleth data can be downloaded in CSV format, with a separate GeoJSON file describing the
          polygons. This allows you to download the data related to multiple map views, while only
          downloading the large geometries once.
        </p>
        <p>
          You will, however, need to join the CSV data to the GeoJSON geometries in order to use the
          data in a GIS.
        </p>
        <p>
          You can download the data for the current map view, or for the entire dataset.
        </p>
        <p>
          <button class="btn btn-primary btn-sm" (click)="downloadCurrentChoroplethView()">
            <i class="fa fa-eye"></i> Download data for current map (CSV)
          </button>
        </p>
        <p>
          <button class="btn btn-primary btn-sm" (click)="downloadMonthlyZonalStatistics()">
            <i class="fa fa-table"></i> Download original monthly time series (CSV)
          </button>
        </p>
        <hr/>
        <p>Required for use in GIS:</p>
        <p>
          <a class="btn btn-primary btn-sm" [href]="geojsonURL" target="_blank">
            <i class="fa fa-globe"></i> Download vectors (GeoJSON - {{geojsonSizeMb}}MB)
          </a>
        </p>
        <p><i>Download once for {{boundaries.name}}.</i></p>
      </div>

      <div *ngSwitchCase="2">
        <p>Time series data for individual points can be downloaded from the time series chart.</p>
        <p>Bulk downloads are available from the NCI:</p>
        <p>
          <a class="btn btn-primary btn-sm" [href]="pointURL" target="_blank">NCI THREDDS Server</a>
        </p>
      </div>

      <div *ngSwitchCase="3">
        <p>Downloading data for vectors.</p>
        <p>
          <button class="btn btn-primary btn-sm" (click)="downloadData('vectors')">Download data</button>
        </p>
      </div>

      <div *ngSwitchCase="4">
        <p>Downloading data for point data.</p>
        <p>
          <button class="btn btn-primary btn-sm" (click)="downloadData('points')">Download data</button>
        </p>
      </div>

      <div *ngSwitchCase="5">
        <p>Downloading gridded data.</p>
        <p>
          <button class="btn btn-primary btn-sm" (click)="downloadData('gridded')">Download data</button>
        </p>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
  </div>
</div>



<!--

Download map image.. possibly using html2canvas, but need to
configure leaflet with `renderer: L.canvas()` to make it work.

-->
